import { render } from "./InvestigationTab.vue?vue&type=template&id=20ea24f1"
import script from "./InvestigationTab.vue?vue&type=script&lang=js"
export * from "./InvestigationTab.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Projects\\KneeLeadNew\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__